export enum JobRequestTabId {
  APPROVE = 'APPROVE',
  REQUEST = 'REQUEST',
}
